<div class="content mt-5">
    <div class="row">
        <div class="col-lg-4">
            <button (click)="navigateTo('amena/convergente')" class="btn btn-black-outline btn-block mb-1 pt-3 pb-3" type="button">Flujo convergente</button>
        </div>

        <div class="col-lg-4">
            <button (click)="navigateTo('amena/solo_movil')" class="btn btn-black-outline btn-block mb-1 pt-3 pb-3" type="button">Flujo móvil</button>
        </div>

        <div class="col-lg-4">
            <button (click)="navigateTo('amena/listado')" class="btn btn-black-outline btn-block mb-1 pt-3 pb-3" type="button">Listado de activaciones</button>
        </div>
    </div>
</div>
